__turbopack_context__.v({
  "blockSimpleImageParagraph": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__blockSimpleImageParagraph",
  "buttonWrapper": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__buttonWrapper",
  "content": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__content",
  "copy": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__copy",
  "flushBottom": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__flushBottom",
  "flushTop": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__flushTop",
  "image": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__image",
  "inner": "BlockSimpleImageParagraph-module-scss-module__iLXXcW__inner",
});
